import { createGlobalStyle } from 'styled-components'
import 'antd/dist/antd.min.css'
export const GlobalStyled = createGlobalStyle `

   
    body {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        font-family: 'Roboto', sans-serif;
    }
`